import { Inject, Injectable } from '@angular/core';
import { ENV, IEnvironment } from 'env/config';

import { DataService } from '../http/dataService';
import { Ams } from '../models/ams.model';
import { Repository } from './repository';

import { Service } from '../entity';

@Service({
  model: Ams,
})
@Injectable({ providedIn: 'root' })
export class AmsService extends Repository<Ams> {
  constructor(@Inject(ENV) env: IEnvironment, dataService: DataService) {
    super({
      client: dataService,
      url: env.api.backend.ams.endpoint as string,
    });
  }

  createFromDTO(item): Ams {
    return item;
  }
}
